export default "__VITE_ASSET__0114717a__"